import { useEffect, useState } from "react";

import { cloneDeep } from "lodash";
import CreateRecordButtonLayout from "../layout/CreateRecordButtonLayout";
import MomSysCreateStockTakingDialog from "../dialogTypes/MomSysCreateStockTakingDialog";

function MomSysCreateStockTakingDetailButton ( props ) {

    const { id, schema, refresh, onSuccess, createButtonName, stockTakingId ,customizeErrorMsgCallback,materialType, ...others } = props;

    const [modifiedSchema, setModifiedSchema] = useState();

    const [ open, setOpen ] = useState(false);

    useEffect(() => {

        if(schema) {

            let modifiedSchema = cloneDeep(schema);

            delete modifiedSchema.formGroups;

            for(const column of modifiedSchema.columns) {

                switch(column.name) {

                    case "stockTakingId" : 
                    case "lotNo" : 
                    case "workState" :
                    case "qty" :
                        column.hideInForm = true;
                        break;

                    case "wareHouseCode" :
                        column.hideInForm = false;
                        column.formGroup = 0;
                        column.formOrder = 10;
                        break;

                    case "qtyDueDiligence" :
                        column.formGroup = 0;
                        column.formOrder = 20;
                        break;

                    case "description" :
                        column.formGroup = 0;
                        column.formOrder = 30;
                        break;

                    default :
                }

            }

            setModifiedSchema(modifiedSchema);

        }



    },[schema])

    const onOpen = () => {

        setOpen ( true );

    };

    const onClose = () => {

        setOpen ( false );

    };

    const onCreateSuccess = ( msg ) => {

        if ( onSuccess ) {

            onSuccess ( msg );

        }

        refresh.refresh ();

    };

    return (

        <>
            <CreateRecordButtonLayout id={id+"create-button"} onClick={onOpen} createButtonName ={createButtonName} {...others} />
            <MomSysCreateStockTakingDialog
                id={id+"create-dialog"}
                schema={modifiedSchema}
                initialData={undefined}
                open={open}
                onClose={onClose}
                onSuccess={onCreateSuccess}
                stockTakingId = {stockTakingId}
                materialType = {materialType}
            />
        </>

    );
}

export default MomSysCreateStockTakingDetailButton;

